import CmcdDataBuilder from "./cmcd_data_builder";
export default CmcdDataBuilder;
